export enum ProductStatus {
  Unknown = 0,
  Active = 1,
  InActive = 2,
  RemovedFromSource = 3,
  Excluded = 4,
  Restricted = 5
}

export const ProductStatusConfig: Record<
  ProductStatus,
  { label: string; icon: string; color: string; tooltipText: string }
> = {
  [ProductStatus.Unknown]: {
    label: 'Active',
    icon: 'mdi-check-circle-outline',
    color: 'success',
    tooltipText: 'messages.productStatusNoneTooltip'
  },
  [ProductStatus.Active]: {
    label: 'Active',
    icon: 'mdi-check-circle-outline',
    color: 'success',
    tooltipText: 'messages.productStatusActiveTooltip'
  },
  [ProductStatus.InActive]: {
    label: 'Inactive',
    icon: 'mdi-alert-circle-outline',
    color: 'grey',
    tooltipText: 'messages.productStatusInActiveTooltip'
  },
  [ProductStatus.RemovedFromSource]: {
    label: 'Removed From Source',
    icon: 'mdi-alert-circle-outline',
    color: 'grey',
    tooltipText: 'messages.productStatusRemovedFromSourceTooltip'
  },
  [ProductStatus.Excluded]: {
    label: 'Excluded',
    icon: 'mdi-cancel',
    color: 'grey',
    tooltipText: 'messages.productStatusExcludedTooltip'
  },
  [ProductStatus.Restricted]: {
    label: 'Restricted',
    icon: 'mdi-alert-circle-outline',
    color: 'warning',
    tooltipText: 'messages.productStatusRestrictedTooltip'
  }
}
